import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import * as Roles from '../../common/Roles';

const states: Ng1StateDeclaration[] = [
    {
        name: 'administration',
        url: '/administration',
        component: 'wtAdministrationContainerState',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator])
        },
        abstract: false,
        redirectTo: 'administration.general',
        data: {
            displayName: 'Administration',
            editButtonVisibility: () => false,
            hideWhenConnected: true,
            icon: 'fa-cog',
            sortingOrder: 103,
            subStates: ['general', 'configuration'],
            visible: true,
        },
    }, {
        name: 'administration.general',
        url: '/general',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator])
        },
        data: {
            displayName: 'Administration',
            icon: 'fa-cog',
            sortingOrder: 103,
            visible: false,
        },
        views: {
            main: {
                template: `<wt-administration-state class="flex-directive"></wt-administration-state>`
            },
        }
    }, {
        name: 'administration.configuration',
        url: '/configuration',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator])
        },
        data: {
            displayName: 'Configurations',
            icon: 'fa-sliders',
            sortingOrder: 103,
            visible: false,
        },
        views: {
            main: {
                template: `<wt-configuration-state class="flex-directive"></wt-configuration-state>`
            },
        }
    }
];

export default states;